import { render, staticRenderFns } from "./MoreLinks.vue?vue&type=template&id=2f15ded2&scoped=true"
import script from "./MoreLinks.vue?vue&type=script&lang=js"
export * from "./MoreLinks.vue?vue&type=script&lang=js"
import style0 from "./MoreLinks.vue?vue&type=style&index=0&id=2f15ded2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15ded2",
  null
  
)

export default component.exports